export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑数据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzPriceControlStatus }) => {
      return !['N'].includes(amzPriceControlStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除数据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzPriceControlStatus }) => {
      return !['N'].includes(amzPriceControlStatus)
    },
  },
  {
    text: that.$l('menu_text_confirm') || '确认数据',
    icon: 'el-icon-s-check',
    menuType: 'confirm',
    divided: true,
    allow: 'C',
    disabled: ({ amzPriceControlStatus }) => {
      return !['N'].includes(amzPriceControlStatus)
    },
  },
  {
    text: that.$l('menu_text_confirm_edit') || '数据调整',
    icon: 'el-icon-edit-outline',
    menuType: 'confirmEdit',
    allow: 'X',
    disabled: ({ amzPriceControlStatus }) => {
      return !['Y'].includes(amzPriceControlStatus)
    },
  },
]
